const devFlagSlugs = {
};

export default devFlagSlugs;
